import "../css/style.scss";
jQuery(function () {
  const location = $.getJSON(
    "https://pro.ip-api.com/json/?key=m4a3wr1KiB2OM00",
    function (data) {
      let countryCode = "US";

      if (data.countryCode) {
        countryCode = data.countryCode;
      }

      console.log(countryCode);

      euCountries = [
        "AT",
        "BE",
        "BG",
        "CY",
        "CZ",
        "DK",
        "EE",
        "FI",
        "FR",
        "DE",
        "GR",
        "HU",
        "IE",
        "IT",
        "LV",
        "LT",
        "LU",
        "MT",
        "NL",
        "PL",
        "PT",
        "RO",
        "SK",
        "SI",
        "ES",
        "SE",
      ];
      if (jQuery.inArray(countryCode, euCountries) !== -1) {
        $(".eu-content").show();
      } else if (countryCode == "UK" || countryCode == "GB") {
        $(".uk-content").show();
      } else {
        $(".us-content").show();
      }
    }
  );
});
(function (w, d, s, n, a) {
  if (!w[n]) {
    var l = "call,catch,on,once,set,then,track".split(","),
      i,
      o = function (n) {
        return "function" == typeof n
          ? o.l.push([arguments]) && o
          : function () {
              return o.l.push([n, arguments]) && o;
            };
      },
      t = d.getElementsByTagName(s)[0],
      j = d.createElement(s);
    j.async = !0;
    j.src = "https://cdn.fundraiseup.com/widget/" + a;
    t.parentNode.insertBefore(j, t);
    o.s = Date.now();
    o.v = 4;
    o.h = w.location.href;
    o.l = [];
    for (i = 0; i < 7; i++) o[l[i]] = o(l[i]);
    w[n] = o;
  }
})(window, document, "script", "FundraiseUp", "AMKXBJRU");

// $(document).ready(function () {
//   $(".owl-carousel").owlCarousel();
// });

var slider = jQuery(".owl-carousel");
slider.owlCarousel({
  loop: false,
  margin: 10,
  responsiveClass: true,
  nav: false,
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
});

var progressPers = document.querySelectorAll(".progress-per");

progressPers.forEach(function (progressPer) {
  var per = parseFloat(progressPer.getAttribute("per"));
  progressPer.style.width = per + "%";

  var animatedValue = 0;
  var startTime = null;

  function animate(timestamp) {
    if (!startTime) startTime = timestamp;
    var progress = timestamp - startTime;
    var stepPercentage = progress / 1000; // Dividing by duration in milliseconds (1000ms = 1s)

    if (stepPercentage < 1) {
      animatedValue = per * stepPercentage;
      progressPer.setAttribute("per", Math.floor(animatedValue) + "%");
      requestAnimationFrame(animate);
    } else {
      animatedValue = per;
      progressPer.setAttribute("per", Math.floor(animatedValue) + "%");
    }
  }

  console.log("test");
  requestAnimationFrame(animate);
});

function move() {
  var elem = document.getElementById("myProgressBar");
  var width = 0;
  var id = setInterval(frame, 10);

  function frame() {
    if (width >= 100) {
      clearInterval(id);
    } else {
      width++;
      elem.style.width = width + "%";
    }
  }
}

// Automatically start the progress bar animation on page load (reload)
window.onload = function () {
  move();
};

// Set the date we're counting down to
var countDownDate = new Date("December 31, 2023 00:00:00").getTime();

// Update the count down every 1 second
var x = setInterval(function () {
  // Get today's date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Output the result in an element with id="countDown"
  document.getElementById("count-days").innerHTML = days;
  document.getElementById("count-hours").innerHTML = hours;
  document.getElementById("count-minutes").innerHTML = minutes;
  document.getElementById("count-seconds").innerHTML = seconds;

  //   document.getElementsByClassName("count-period").innerHTML = days + "d " + hours + "h "
  //   + minutes + "m " + seconds + "s ";

  // If the count down is over, write some text
  // if (distance < 0) {
  //   clearInterval(x);
  //   document.getElementById("countDown").innerHTML = "EXPIRED";
  // }
}, 1000);
